import { MockDatabase, MockTable } from "../MockDatabase";

export class MockSchemaTypeName extends MockTable {
    constructor(db: MockDatabase) {
        super(db);
        this.name = 'schema_type_name';
        this.fields = {
            id: this.PrimaryKey({
                fieldName: 'id'
            }),
            schema_type: this.Field({
                type: 'string',
                fieldName: 'schema_type',
                nullable: false,
                index: true
            })
        }
    }
}